import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getMatchSchedule = createAsyncThunk("matchSchedule/get", async ({ entityId, payload }) => {
  try {
    const response = await magnifiAPI.getMatchSchedule({ entityId, payload });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getMatchScheduleById = createAsyncThunk("matchSchedule/getById", async ({ entityId, matchScheduleId }) => {
  try {
    const response = await magnifiAPI.getMatchScheduleById({ entityId, matchScheduleId });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createMatchSchedule = createAsyncThunk(
  "matchSchedule/create",
  async ({ entityId, payload, isFromInternalSchedule }) => {
    try {
      const response = await magnifiAPI.createMatchSchedule({
        entityId,
        payload,
        isFromInternalSchedule,
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const updateMatchSchedule = createAsyncThunk(
  "matchSchedule/update",
  async ({ entityId, matchScheduleId, payload, isFromInternalSchedule }) => {
    try {
      const response = await magnifiAPI.updateMatchSchedule({
        entityId,
        matchScheduleId,
        payload,
        isFromInternalSchedule,
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const validateMatchScheduleCsv = createAsyncThunk(
  "matchSchedule/validateCsv",
  async ({ entityId, payload, isFromInternalSchedule }) => {
    try {
      const response = await magnifiAPI.validateMatchScheduleCsv({
        entityId,
        payload,
        isFromInternalSchedule,
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const bulkCreateMatchSchedule = createAsyncThunk("matchSchedule/bulkCreate", async ({ entityId, payload }) => {
  try {
    const response = await magnifiAPI.bulkCreateMatchSchedule({ entityId, payload });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const validateNewsScheduleCsv = createAsyncThunk(
  "matchSchedule/validateNewsCsv",
  async ({ entityId, payload, isFromInternalSchedule }) => {
    try {
      const response = await magnifiAPI.validateNewsScheduleCsv({
        entityId,
        payload,
        isFromInternalSchedule,
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const bulkCreateNewsSchedule = createAsyncThunk(
  "matchSchedule/bulkCreateNews",
  async ({ entityId, payload }) => {
    try {
      const response = await magnifiAPI.bulkCreateNewsSchedule({ entityId, payload });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const exportMatchScheduleCsv = createAsyncThunk("matchSchedule/exportCsv", async ({ entityId, payload }) => {
  try {
    const response = await magnifiAPI.exportMatchScheduleCsv({ entityId, payload });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const triggerMatchScheduleManualIngestion = createAsyncThunk(
  "matchSchedule/triggerManualIngestion",
  async ({ payload: { entityId } }) => {
    try {
      const response = await magnifiAPI.triggerMatchScheduleManualIngestion({ entityId });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const deleteMatchSchedule = createAsyncThunk("matchSchedule/delete", async ({ entityId, matchScheduleId }) => {
  try {
    const response = await magnifiAPI.deleteMatchSchedule({ entityId, matchScheduleId });

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
